import React from "react";
import { useSelector } from 'react-redux';

import { Route, Switch } from "react-router-dom";

import ShareLibraryModal from "widgets/ShareLibraryModal";
import LibraryPropertiesModal from "widgets/LibraryPropertiesModal";


export default function Modals({ screenPath, returnPath }){
	const libraries = useSelector(state => state.libraries.items);

	return (
		<Switch>
			<Route
				exact
				path   = {`${screenPath}/modal/new/`}
				render = {() => {
					return (
						<LibraryPropertiesModal
							returnPath = { returnPath }
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${screenPath}/modal/edit/:libraryId/`}
				render = {(routeRenderProps) => {
					let { libraryId } = routeRenderProps.match.params;
					return (
						<LibraryPropertiesModal
							libraryId = { libraryId }
							returnPath = { returnPath }
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${screenPath}/modal/share/:libraryId/`}
				render = {(routeRenderProps) => {
					let { libraryId } = routeRenderProps.match.params;
					const library = libraries.find(lib => lib.id === Number(libraryId)) || {};

					return (
						<ShareLibraryModal
							name={library.name}
							libraryId = { libraryId }
							returnPath = { returnPath }
						/>
					);
				}}
			/>
		</Switch>
	);
}

Modals.displayName = "LibraryModals";
